import { status } from '../../config.ts'
import {
  claimsPage1,
  claimDetail55,
  claimDetail56,
  claimsExportCsv
} from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'GET',
    path: '/insurance-claims?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, claimsPage1]
    }
  },
  {
    method: 'GET',
    path: '/insurance-claims/export/to/csv?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, claimsExportCsv]
    }
  },
  {
    method: 'GET',
    path: '/insurance-claims/55',
    reply: async () => {
      await wait()
      return [status.ok, claimDetail55]
    }
  },
  {
    method: 'GET',
    path: '/insurance-claims/56',
    reply: async () => {
      await wait()
      return [status.ok, claimDetail56]
    }
  },
  {
    method: 'PUT',
    path: '/insurance-claims/55',
    reply: async () => {
      await wait()
      return [
        status.ok,
        {
          message: 'Reclamo completado.',
          data: { id: 55, status: 'COMPLETED' }
        }
      ]
    }
  },
  {
    method: 'PUT',
    path: '/insurance-claims/56',
    reply: async () => {
      await wait()
      return [
        status.ok,
        {
          message: 'Reclamo completado.',
          data: { id: 56, status: 'COMPLETED' }
        }
      ]
    }
  }
]
